import routesLimited, { hasProperty } from '@/constants/routesLimited'
import { castRouteIds } from 'plugins/router/routes/castRouteIds'
import type { HideObject, LimitedObject } from 'plugins/router/types'
import type { RouteRecordRaw } from 'vue-router'

const hideCraftsmanTask: HideObject = {
	method: hasProperty,
	parameter: {
		store: 'setting',
		getter: 'getData',
		property: 'hide_craftsman_task',
		value: false,
	},
}

const hasCraftsmanTasks: LimitedObject = {
	method: hasProperty,
	parameter: {
		store: 'user',
		getter: 'modules',
		property: 'craftsman_tasks',
		value: true,
	},
}

const craftsmanTask: RouteRecordRaw = {
	name: 'craftsmanTask',
	path: ':craftsmanTaskId',
	meta: {
		title: 'entity.craftsman_task.name',
		icon: '',
	},
	component: () =>
		import('components/modules/CraftsmanTasks/CraftsmanTaskItem.vue'),
	props: castRouteIds,
}

const craftsmanTaskCreate: RouteRecordRaw = {
	name: 'craftsmanTaskCreate',
	path: '/craftsman_tasks/create',
	component: () =>
		import('components/modules/CraftsmanTasks/CraftsmanTaskCreateEdit.vue'),
	props: true,
	meta: {
		title: 'Handwerkauftrag anlegen',
		limited: routesLimited.isAdminOrTeam,
		subs: [routesLimited.subModules.craftsman_tasks],
	},
}
const craftsmanTasks: RouteRecordRaw = {
	name: 'craftsmanTasks',
	path: '/craftsman_tasks',
	meta: {
		title: 'routeTitle.craftsmanTasks',
		icon: 'fa-fw fa-solid fa-hammer',
		nav: true,
		auth: true,
		ordering: 4,
		hidden: hideCraftsmanTask,
		limited: [routesLimited.isAdminOrTeam, hasCraftsmanTasks],
		subs: [routesLimited.subModules.craftsman_tasks],
	},
	component: () =>
		import('components/modules/CraftsmanTasks/CraftsmanTaskList.vue'),
	children: [craftsmanTask],
}

export { craftsmanTask, craftsmanTasks, craftsmanTaskCreate }
